import ResultContentTable from "./ResultContentTable";
import React from "react";
import BettingBoard from "./BettingBoard";

const DrawingResult = () => {
    return <div className="row col no-padding-div">
        <ResultContentTable/>
        <BettingBoard/>
    </div>
}

export default DrawingResult;